<template>
  <div class="address-page">
    <div class="address-view">
      <h1>{{ trans('addresses.header.title') }}</h1>
      <div v-if="showList" class="address-view__actions">
        <button class="btn btn--primary address-view__actions--add" @click="addressAddMode = true">
          {{ trans('addresses.actions.add_address') }}
        </button>
      </div>

      <onboarding-toggleable-block
        v-if="userSetting.value"
        :url-hide-onboarding="onboardingUrl"
        :user-setting="userSetting"
        class="address-view__onboarding"
      >
        <template #title>
          {{ trans('addresses.onboarding.title') }}
        </template>
        <template #body>
          {{ trans('addresses.onboarding.text') }}
        </template>
      </onboarding-toggleable-block>

      <address-add-c-t-a v-if="showCTA" @click="addressAddMode = true" />

      <spinner-container v-if="loading" />

      <address-list
        v-if="showList"
        :address-add-mode="addressAddMode"
        :addresses="addresses"
        @changed="load"
        @add-cancelled="addressAddMode = false"
      />

      <div class="gr-12">
        <pagination
          v-if="nbPages > 1"
          :nb-items="total"
          :nb-pages="nbPages"
          :offset-end="offsetEnd"
          :offset-start="offsetStart"
          :page="page"
          @go-page="goToPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@components/Pagination.vue';
import SpinnerContainer from '@components/SpinnerContainer.vue';
import OnboardingToggleableBlock from '@components-molecules/OnboardingToggleableBlock.vue';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';
import { Logger } from '@tools/logger/logger';
import { URL_USER_SETTINGS_ONBOARDING_SPACES, URL_XHR_ADDRESSES } from '@tools/routes/routes';
import { translationMixin } from '@elements/translation';
import { requestsMixin } from '@tools/requests-mixin';
import AddressAddCTA from './AddressAddCTA.vue';
import AddressList from './AddressList.vue';

export default {
  components: { SpinnerContainer, AddressList, AddressAddCTA, Pagination, OnboardingToggleableBlock },
  mixins: [ translationMixin, requestsMixin ],
  data() {
    return {
      page: 1,
      addresses: null,
      total: null,
      perPage: window.PER_PAGE,
      userSetting: window.USER_SETTINGS,
      addressAddMode: false,
      initLoading: true,
      loading: true,
    };
  },
  computed: {
    showList() {
      return !this.initLoading && (this.addresses?.length > 0 || this.addressAddMode);
    },
    showCTA() {
      return this.addresses?.length === 0 && !this.loading && !this.addressAddMode;
    },
    nbPages() {
      return Math.ceil(this.total / this.perPage);
    },
    offsetStart() {
      return (this.page - 1) * this.perPage + 1;
    },
    offsetEnd() {
      return Math.min(this.page * this.perPage, this.total);
    },
    onboardingUrl() {
      return URL_USER_SETTINGS_ONBOARDING_SPACES;
    },
  },
  watch: {
    page(val) {
      this.load({ page: val });
    },
  },
  mounted() {
    if (window.FROM_DELETION) {
      flashBagSuccess(this.trans('addresses.body.table.form.message.remove_success'));
      window.history.pushState({}, document.title, window.location.pathname);
    }
    this.load();
  },
  methods: {
    mapAddresses(json) {
      return json.map((element) => {
        const address = element[0];
        address.nbOffers = Number(element.nb_offers) || 0;
        return address;
      });
    },
    goToPage(page) {
      this.page = page;
    },
    async load() {
      this.loading = true;

      const queryParams = new URLSearchParams();
      queryParams.append('page', this.page);

      try {
        const { data } = await this.get(`${URL_XHR_ADDRESSES}?${queryParams.toString()}`);
        this.addresses = this.mapAddresses(data.addresses);
        this.total = data.total;
      } catch (err) {
        Logger.error('Error catched', err);
        flashBagError();
      }
      this.addressAddMode = false;
      this.loading = false;
      this.initLoading = false;
    },
  },
};
</script>
